import React from 'react';
import { SiteInformation } from 'components/Report/SiteInformation';
import { IconFooter } from 'components/IconFooter';

import alt from 'js/alt';
import { mapStore } from 'stores/MapStore';
import { reportStore } from 'stores/ReportStore';
import { criteriaStore } from 'stores/CriteriaStore';

import { mapActions } from 'actions/MapActions';
import { reportActions } from 'actions/ReportActions';
import { criteriaActions } from 'actions/CriteriaActions';

import { loadJS } from 'utils/LoaderUtil';
import { checkIfSquaredJsx } from 'utils/Utilities';

import _ from 'lodash';
import { Promise as bbPromise } from 'promise';

class LoadControl extends React.Component {
  updateAndShowLoadDetails() {
    reportActions.updateAndShowLoadDetails(this.props.load);
    this.props.toggleLeftPanel();
  }

  handleChange(evt) {
    mapActions.updateLayerVisibility({
      id: this.props.load.label,
      checked: evt.target.checked,
    });
    this.props.toggleLeftPanel();
  }

  render() {
    let sampleDatas = [];
    _.forEach(this.props.load.sampleData.value, (value, itt) => {
      let items = checkIfSquaredJsx(value);
      const classes =
        'loads-container__main-details' +
        ((typeof items === 'string' && items.indexOf('Failed') > -1) ||
        (typeof items === 'string' && items.indexOf('Special Wind Region') > -1)
          ? ' load-failed'
          : '');
      sampleDatas.push(
        <div key={itt}>
          <span className={classes}>{items}</span>
        </div>
      );
    });

    return (
      <div id='loads-container' className='loads-container padding--small'>
        <div id='loads-container__title' className='loads-container__title'>
          <span className='loads-container__label'>{this.props.load.label}</span>
          {this.props.load.label !== 'Tornado' && (
            <div className='loads-container__checkbox switch'>
              <span className='grey-text text-light-1'>Overlay</span>
              <label>
                <input type='checkbox' checked={this.props.load.visible} onChange={this.handleChange.bind(this)} />
                <span className='lever' />
              </label>
            </div>
          )}
        </div>
        <div id='loads-container__content' className='loads-container__content'>
          <div className='flex flex-row flex-justify-between fill__wide align-items-center'>
            <div>{sampleDatas}</div>
            <a
              className={`loads-details waves-effect waves-light btn blue darken-4 ${
                this.props.load.showInReport ? '' : 'disabled'
              }`}
              onClick={this.updateAndShowLoadDetails.bind(this)}
            >
              Details
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export class Report extends React.Component {
  constructor(props) {
    super(props);
    reportStore.listen(this.storeUpdated.bind(this));
    this.state = { ...reportStore.getState() };

    window.define = undefined;
    //load Report Libraries
    let jsLoads = [];
    let url = 'app/vendor/bower-pdfkit/pdfkit-0.7.1.js';
    jsLoads.push(loadJS(url));
    url = 'app/vendor/file-saver/dist/FileSaver.js';
    jsLoads.push(loadJS(url));
    url = 'app/vendor/bower-pdfkit/blob-stream-v0.1.3.js';
    jsLoads.push(loadJS(url));
    bbPromise.all(jsLoads).then(() => {
      reportActions.reportLibrariesLoaded();
    });
  }

  storeUpdated() {
    const store = { ...reportStore.getState() };
    this.setState(store);
  }

  buildReport(state) {
    if (state.queriesComplete && state.librariesLoaded) {
      reportActions.showReportBuildPopup();
      reportActions.buildReport(this.props.loginInfo);
      reportActions.togglePreloader(true);
    }
    mapActions.hideLegend();
  }

  showSummary() {
    reportActions.showSummary();
  }

  undoReport() {
    //turn off all map layers
    criteriaActions.hideReport();
    alt.recycle(reportStore);
    if (typeof window.PDFDocument !== 'undefined') {
      reportActions.reportLibrariesLoaded();
    }

    _.forEach(mapStore.getState().map.layerIds, (id) => {
      if (id === 'layer0' || id === 'layer1' || _.includes(id, 'layer')) {
        return;
      }
      mapStore.getState().map.getLayer(id).setVisibility(false);
    });
    mapActions.updateLegend();
  }

  render() {
    let reportLoads = [];
    _.forEach(this.state.loads, (load, i) => {
      if (load.checked === 'checked') {
        reportLoads.push(<LoadControl load={load} key={i} toggleLeftPanel={this.props.toggleLeftPanel} />);
      }
    });

    const reportFinished = this.state.queriesComplete && this.state.librariesLoaded ? '' : 'disabled';
    const reportButton = this.state.reportIsBuilding ? <Preloader /> : 'Full Report';

    return (
      <div id={'report'} className={'report-panel'}>
        <SiteInformation
          elevation={this.state.elevation}
          elevationReferenceDatum={this.state.elevationReferenceDatum}
          undoReport={this.undoReport.bind(this)}
          toggleLeftPanel={this.props.toggleLeftPanel.bind(this)}
        />
        <div className='report-additional-selection-container padding--small white'>
          <div className='individual-selection-container'>{reportLoads}</div>
        </div>
        <div className='full-report-container padding--small white'>
          <div id='tornado-table-hidden' style={{ display: 'none' }} />
          <a
            onClick={this.buildReport.bind(this, this.state)}
            className={`waves-effect waves-light btn-large blue darken-4 report-button ${reportFinished}`}
          >
            {reportButton}
          </a>
          <a
            onClick={this.showSummary.bind(this, this.state)}
            className={`waves-effect waves-light btn-large blue darken-4 report-button ${reportFinished}`}
          >
            Summary
          </a>
        </div>
        <IconFooter />
      </div>
    );
  }
}

class Preloader extends React.Component {
  render() {
    return (
      <div id='preloader-container' className='flex flex-row flex-justify-between align-items-center'>
        <div>Building</div>
        <div>
          <div id='preloader' className={`preloader-wrapper small active`}>
            <div className='spinner-layer spinner-blue-only'>
              <div className='circle-clipper left'>
                <div className='circle'></div>
              </div>
              <div className='gap-patch'>
                <div className='circle'></div>
              </div>
              <div className='circle-clipper right'>
                <div className='circle'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
